const state = {
    developMode: import.meta.env.VITE_MODE === 'development',
    snackbar: {show: false, message: ''}
};

const getters = {
    developMode: state => state.developMode,
    snackbar: state => state.snackbar,
};

const actions = {
    async setDevelopMode({commit}, developMode){
        commit("setDevelopMode", developMode)
    },
    showSnackbar({commit}, settings){
        commit("setSnackbar", {show:true, duration: settings.duration, message: settings.message, type: settings.type})
    },
};

const mutations = {
    setDevelopMode: (state, developMode) => (
        state.developMode = developMode
    ),
    setSnackbar: (state, snackbar) => {
        if (!snackbar.duration) {
            snackbar.duration = 3000
        }
        state.snackbar = snackbar
        setTimeout(t => {
            state.snackbar = {show: false}
        }, snackbar.duration)
    }
};

export default {
    state,
    getters,
    actions,
    mutations
}